import { render, staticRenderFns } from "./PreThirdPersonDigitalSignContract.vue?vue&type=template&id=16a70d6a&scoped=true"
import script from "./PreThirdPersonDigitalSignContract.vue?vue&type=script&lang=js"
export * from "./PreThirdPersonDigitalSignContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a70d6a",
  null
  
)

export default component.exports